const DataNilaiAfektif = [
  {
    id: "1",
    indikator: "Tanggung Jawab",
    predikat: "A"
  },
  {
    id: "2",
    indikator: "Disiplin",
    predikat: "B"
  },
  {
    id: "3",
    indikator: "Kreativitas",
    predikat: "A"
  },
]

export default DataNilaiAfektif